import React from 'react';
import { cn } from '../../lib/cn';

export const Input = React.forwardRef(function Input(
  {
    leftIcon: LeftIcon,
    rightSlot,
    error = false,
    className,
    inputClassName,
    ...rest
  },
  ref
) {
  return (
    <div className={cn('relative w-full', className)}>
      {LeftIcon ? (
        <LeftIcon className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-slate-400 pointer-events-none" />
      ) : null}
      <input
        ref={ref}
        className={cn(
          'w-full h-9 px-3 text-sm bg-white border rounded-md shadow-soft text-slate-900 placeholder:text-slate-400',
          'transition-colors duration-150',
          'focus:outline-none focus:ring-2',
          error
            ? 'border-rose-300 focus:border-rose-500 focus:ring-rose-100'
            : 'border-slate-200 focus:border-brand-500 focus:ring-brand-100',
          LeftIcon && 'pl-8',
          rightSlot && 'pr-9',
          inputClassName
        )}
        {...rest}
      />
      {rightSlot ? (
        <div className="absolute right-1.5 top-1/2 -translate-y-1/2 flex items-center">
          {rightSlot}
        </div>
      ) : null}
    </div>
  );
});

export function FieldLabel({ className, children, htmlFor, ...rest }) {
  return (
    <label htmlFor={htmlFor} className={cn('block text-[12px] font-medium text-slate-700 mb-1.5', className)} {...rest}>
      {children}
    </label>
  );
}

export function FieldHint({ tone = 'default', className, children }) {
  const tones = {
    default: 'text-slate-500',
    error: 'text-rose-600',
    success: 'text-emerald-600'
  };
  return (
    <p className={cn('text-[12px] mt-1.5', tones[tone], className)}>{children}</p>
  );
}

export const FieldGroup = React.forwardRef(function FieldGroup(
  { className, ...rest },
  ref
) {
  return <div ref={ref} className={cn('flex flex-col', className)} {...rest} />;
});

export default Input;
